import { render, staticRenderFns } from "./AutomationInsights.vue?vue&type=template&id=2b674ee2&scoped=true"
import script from "./AutomationInsights.vue?vue&type=script&lang=js"
export * from "./AutomationInsights.vue?vue&type=script&lang=js"
import style0 from "./AutomationInsights.vue?vue&type=style&index=0&id=2b674ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b674ee2",
  null
  
)

export default component.exports